import BigNumber from 'bignumber.js'
import LocalBalance from 'components/LocalBalance'
import { getBalanceAmount, formatTokenAmount } from 'utils/formatBalance'
import { Flex, Text } from 'vvs-uikit'
import Tokens from 'config/constants/tokens'

export const getTotalApr = (tokenRewardsApr?: number, lpRewardsApr?: number): number => {
  if (tokenRewardsApr && lpRewardsApr) {
    return tokenRewardsApr + lpRewardsApr
  }
  if (tokenRewardsApr) {
    return tokenRewardsApr
  }
  return 0
}

export const getDisplayApr = (tokenRewardsApr?: number, lpRewardsApr?: number, digits = 2) => {
  const totalApr = getTotalApr(tokenRewardsApr, lpRewardsApr)
  return totalApr > 0 ? totalApr.toLocaleString('en-US', { maximumFractionDigits: digits }) : null
}

export const getTotalBoostedApr = (
  vvsRewardsApr?: number,
  tokenRewardsApr?: number,
  lpRewardsApr?: number,
  vvsBoostFactor = 1,
  ecoBoostFactor = 1,
) => {
  const boostedTokenApr = vvsRewardsApr * vvsBoostFactor + (tokenRewardsApr - vvsRewardsApr) * ecoBoostFactor
  return getTotalApr(boostedTokenApr, lpRewardsApr)
}

export const getBoostedDisplayApr = (
  vvsRewardsApr?: number,
  tokenRewardsApr?: number,
  lpRewardsApr?: number,
  vvsBoostFactor = 1,
  ecoBoostFactor = 1,
  digits = 2,
) => {
  const boostedTokenApr = vvsRewardsApr * vvsBoostFactor + (tokenRewardsApr - vvsRewardsApr) * ecoBoostFactor
  return getDisplayApr(boostedTokenApr, lpRewardsApr, digits)
}

export const renderBoostEarnings = (data: BigNumber, vvsPrice: BigNumber): JSX.Element => {
  const earnings = getBalanceAmount(data)
  const rewardsUsdc: BigNumber = earnings.times(vvsPrice)
  const token = Tokens.vvs
  return (
    <Flex key={token.symbol} flexDirection="column" mt="6px">
      <Text fontSize="18px" bold>{`${token.symbol} ${formatTokenAmount(token, earnings)}`}</Text>
      {rewardsUsdc.gt(0) ? (
        <LocalBalance fontSize="12px" color="textSubtle" decimals={2} value={rewardsUsdc} prefix="~" />
      ) : (
        <Text />
      )}
    </Flex>
  )
}
